import * as React from 'react';
import { connect } from 'react-redux';
import IconButton from '../../common/IconButton';
import NewToolbarItemScroller from '../../common/toolbar-item-scroller/NewToolbarItemScroller';
import { Level } from '../../header-toolbar/NewHeaderToolbar';
import CurrentToolIcon from '../../header-toolbar/CurrentToolIcon';
import { Dispatch, Action } from 'redux';
import UIAction from '../../../actions/ui/UIAction';
import { CurrentTool } from '../../../reducers/ui/ui';
import FreehandPenUIAction from '../../../actions/ui/FreehandPenUIAction';
import { PagesState } from '../../../reducers/pages';
import { Publication } from '../../../types/epub';
import {
  IntegratedDrawingState, getPrevDrawingPage, getNextDrawingPage, canUndoDrawing, canRedoDrawing,
} from '../../../reducers/integratedDrawing';
import { getEditorKeyAndPage } from '../../../helpers/integratedDrawings';
import HistoryAction from '../../../actions/HistoryAction';
import { PageAction, AppStates } from '../../../../../..';
import FreehandPenToolIconButton from './FreehandPenToolIconButton';
import { DialogType } from '../../common/SettingDialogContainer';

interface HeaderToolbarFreehandPenLevelProps {
  readonly isVertical: boolean;
  readonly pages: PagesState;
  readonly publication?: Publication;
  readonly integratedDrawing: IntegratedDrawingState;
  readonly pushLevel: (level: Level) => void;
  readonly popToTopLevel: () => void;
  readonly setDialogType: (dialogType: DialogType) => void;
  readonly dispatch: Dispatch<Action>;
}

class HeaderToolbarFreehandPenLevel extends React.PureComponent<
  HeaderToolbarFreehandPenLevelProps
> {
  private handleUndo = () => {
    const { pages, publication, integratedDrawing, dispatch } = this.props;
    if (publication === undefined) {
      return;
    }

    const index = getEditorKeyAndPage(pages, publication);
    const page = getPrevDrawingPage(integratedDrawing, index);
    dispatch(HistoryAction.undo());

    if (page !== null) {
      PageAction.moveToPage(pages.activeTab, page, dispatch);
    }
  }

  private handleRedoDrawing = () => {
    const { pages, publication, integratedDrawing, dispatch } = this.props;
    if (publication === undefined) {
      return;
    }

    const index = getEditorKeyAndPage(pages, publication);
    const page = getNextDrawingPage(integratedDrawing, index);
    dispatch(HistoryAction.redo());

    if (page !== null) {
      PageAction.moveToPage(pages.activeTab, page, dispatch);
    }
  }

  public render() {
    const {
      isVertical,
      integratedDrawing,
      pages,
      publication,
      pushLevel,
      popToTopLevel,
      setDialogType,
      dispatch,
    } = this.props;

    const canUndo = publication !== undefined
      ? canUndoDrawing(integratedDrawing, getEditorKeyAndPage(pages, publication))
      : false;

    const canRedo = publication !== undefined
      ? canRedoDrawing(integratedDrawing, getEditorKeyAndPage(pages, publication))
      : false;

    return (
      <>
        <CurrentToolIcon />

        <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
          <FreehandPenToolIconButton
            buttonNumber={0}
            title="ペン1"
            onClick={() => {
              UIAction.setCurrentTool(CurrentTool.FreeHandPen, dispatch);
              FreehandPenUIAction.selectTool(0, dispatch);
            }} />
          <FreehandPenToolIconButton
            buttonNumber={1}
            title="ペン2"
            onClick={() => {
              UIAction.setCurrentTool(CurrentTool.FreeHandPen, dispatch);
              FreehandPenUIAction.selectTool(1, dispatch);
            }} />
          <FreehandPenToolIconButton
            buttonNumber={2}
            title="ペン3"
            onClick={() => {
              UIAction.setCurrentTool(CurrentTool.FreeHandPen, dispatch);
              FreehandPenUIAction.selectTool(2, dispatch);
            }} />
          <FreehandPenToolIconButton
            buttonNumber={3}
            title="ペン4"
            onClick={() => {
              UIAction.setCurrentTool(CurrentTool.FreeHandPen, dispatch);
              FreehandPenUIAction.selectTool(3, dispatch);
            }} />
          <IconButton
            title="ペン設定"
            imagePath="images/tool-icons/new/pen_setting/pen_setting"
            rouondRect={true}
            onClick={() => setDialogType(DialogType.FreehandPen)} />
          <IconButton
            title="UNDO"
            imagePath="images/tool-icons/new/undo/undo"
            rouondRect={true}
            disabled={!canUndo}
            onClick={this.handleUndo} />
          <IconButton
            title="REDO"
            imagePath="images/tool-icons/new/redo/redo"
            rouondRect={true}
            disabled={!canRedo}
            onClick={this.handleRedoDrawing} />
          <IconButton
            title="消しゴム"
            imagePath="images/tool-icons/new/eraser/eraser"
            rouondRect={true}
            onClick={() => {
              UIAction.setCurrentTool(CurrentTool.Handerasing, dispatch);
              pushLevel(Level.Handerasing);
            }} />
          <IconButton
            title="ゴミ箱"
            imagePath="images/tool-icons/new/trashbox/trashbox"
            rouondRect={true}
            onClick={() => {
              UIAction.setCurrentTool(CurrentTool.AllErasing, dispatch);
              pushLevel(Level.AllErasing);
            }} />
        </NewToolbarItemScroller>

        <IconButton
          title="戻る"
          imagePath="images/tool-icons/new/btn_top/btn_top"
          rouondRect={true}
          onClick={popToTopLevel} />
      </>
    );
  }
}

const mapStateToProps = (appStates: AppStates) => {
  const { pages, publication, integratedDrawing } = appStates;
  return { pages, publication, integratedDrawing };
};

export default connect(mapStateToProps)(HeaderToolbarFreehandPenLevel);
